import { Grid, Typography, Button } from "@mui/material";
import usePersonStore from "../../../../store/personStore"
export type SCREEN_SUBSCRIPTION_OPTION = "TWS_EN" | "TS_EN" | "TWS_ES" | "TNS_EN"
// 
export type SCREEN_TYPE_REQUEST_OPTION = "tScreen" | "TweenScreen" | "TeenScreen";

export type SelectScreenProps = {
    onSelect: (screen: SCREEN_SUBSCRIPTION_OPTION,) => void;
}
export default function SelectScreenVersion({ onSelect }: SelectScreenProps) {
    const subscriptions = usePersonStore(state => state.company.subscriptions)
    return (
        <>
            <Grid size={12} alignItems="center">
                <Typography>Select a screen that you would like to launch</Typography>
            </Grid>
            <Grid size={12} alignItems="center">
                <Button sx={{
                    backgroundColor: "primary.main", "&:hover": {
                        backgroundColor: "primary.light",
                    },
                    width: 180,
                    marginTop: "16px",
                    padding: 1
                }} type="submit"
                    variant="contained"
                    disabled={!subscriptions.some(sub => sub.name === "TS_EN")}
                    onClick={() => onSelect("TS_EN")}>
                    {!subscriptions.some(sub => sub.name === "TS_EN") ?
                        <Grid container spacing={0}>
                            <Grid size={12}>
                                tScreen<br />(Ages 5-9)
                            </Grid>
                            <Grid size={12}>
                                <p style={{ margin: 0, fontSize: "11px" }}>Add to your subscription</p>
                            </Grid>
                        </Grid>
                        : <> tScreen<br />(Ages 5-9)</>}
                </Button>
            </Grid>
            <Grid size={12} alignItems="center">
                <Button sx={{
                    backgroundColor: "primary.main", "&:hover": {
                        backgroundColor: "primary.light",
                    },
                    width: 180,
                    marginTop: "16px",
                    padding: 1
                }} type="submit"
                    variant="contained"
                    disabled={!subscriptions.some(sub => sub.name === "TWS_EN")}
                    onClick={() => onSelect("TWS_EN")}>
                    {!subscriptions.some(sub => sub.name === "TWS_EN") ?
                        <Grid container spacing={0}>
                            <Grid size={12}>
                                TweenScreen<br />(Ages 9-16)
                            </Grid>
                            <Grid size={12}>
                                <p style={{ margin: 0, fontSize: "11px" }}>Add to your subscription</p>
                            </Grid>
                        </Grid>
                        : <> TweenScreen<br />(Ages 9-16)</>}
                </Button>
            </Grid>
            <Grid size={12} alignItems="center">
                <Button
                    sx={{
                        backgroundColor: "primary.main", "&:hover": {
                            backgroundColor: "primary.light",
                        },
                        width: 180,
                        marginTop: "16px",
                        padding: 1
                    }}
                    disabled
                    // disabled={!subscriptions.some(sub => sub.name === "TNS_EN")}
                    type="submit"
                    variant="contained"
                    onClick={() => onSelect("TNS_EN")}>
                    {/* {!subscriptions.some(sub => sub.name === "TNS_EN") ?
                        <Grid container spacing={0}>
                            <Grid size={12}>
                            TeenScreen<br />(Ages 12-18)
                            </Grid>
                            <Grid size={12}>
                                <p style={{ margin: 0, fontSize: "11px" }}>Add to your subscription</p>
                            </Grid>
                        </Grid>
                        : <> TeenScreen<br />(Ages 12-18)</>} */}
                    <Grid container spacing={0}>
                        <Grid size={12}>
                            TeenScreen<br />(Ages 12-18)
                        </Grid>
                        <Grid size={12}>
                            <p style={{ margin: 0, fontSize: "11px" }}>Coming Soon</p>
                        </Grid>
                    </Grid>
                </Button>
            </Grid>
            <Grid size={12} alignItems="center">
                <Button
                    sx={{
                        backgroundColor: "primary.main", "&:hover": {
                            backgroundColor: "primary.light",
                        },
                        width: 180,
                        marginTop: "16px",
                        padding: 1
                    }}
                    disabled={!subscriptions.some(sub => sub.name === "TWS_ES")}
                    type="submit"
                    variant="contained"
                    onClick={() => onSelect("TWS_ES")}>
                    {subscriptions.some(sub => sub.name === "TWS_ES") ?
                        <Grid container spacing={0}>
                            <Grid size={12}>
                                Spanish TweenScreen<br />(Ages 12-18)
                            </Grid>
                            <Grid size={12}>
                                <p style={{ margin: 0, fontSize: "11px" }}></p>
                            </Grid>
                        </Grid>
                        : <Grid container spacing={0}>
                            <Grid size={12}>
                                Spanish TweenScreen<br />(Ages 12-18)
                            </Grid>
                            <Grid size={12}>
                                <p style={{ margin: 0, fontSize: "11px" }}>Add to your subscription</p>
                            </Grid>
                        </Grid>}

                </Button>
            </Grid>
        </>
    )
}